import React from 'react';
import PropTypes from 'prop-types';
import LeadersHero from '../components/Leaders/LeadersHero';
import { useLeaders } from '../hooks/leaders';
import LeadersRow from '../components/Leaders/LeadersRow';
import Loader from '../components/Loader';

export default function LeadersTableBody({ type, limit = 10 }) {
  const [leaders, loading] = useLeaders(type, limit);

  if (loading) return <Loader />;

  if (leaders?.length > 0) {
    return (
      <div className="d-flex">
        <div className="stats-table__player-image d-none d-lg-flex pt-3">
          {leaders?.length > 0 && <LeadersHero player={leaders[0]} />}
        </div>
        <div className="flex-grow-1">
          {leaders?.map((player) => (
            <LeadersRow key={player.id} player={player} />
          ))}
          {limit === 5 && (
            <div className="flex-grow-1 mt-3 mb-3 px-2">
              <a
                className="button button--primary-blue button--large d-block text-center"
                href="/tabell"
              >
                SE TOPP 10
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="text-center p-4">
      {type === 'assists' ? 'Assistligan' : 'Skytteligan'} för denna säsong är
      inte tillgänglig
    </div>
  );
}

LeadersTableBody.propTypes = {
  type: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired,
};
